import { FC } from 'react'
import { FilterSection } from '@/network/graphql.g'
import MobileFilterGridItem, {
  MobileFilterItemType
} from './mobileFilterGridItem'

type Props = {
  colors: FilterSection[]
  initialSelections: string[]
  updatePendingFilter: (ids: string[]) => void
}

const FilterColorsSlidePage: FC<Props> = ({
  colors,
  initialSelections,
  updatePendingFilter
}) => {
  const items: MobileFilterItemType[] = colors.flatMap((s) =>
    s.items.map((i) => ({
      id: i.id,
      title: i.title,
      value: i.value,
      count: i.count
    }))
  )

  return (
    <MobileFilterGridItem
      items={items}
      selectedIds={initialSelections}
      onSelectionChange={updatePendingFilter}
      isColorVariant={true}
    />
  )
}
export default FilterColorsSlidePage
